/**
 * User: WangMeng
 * Desc: 监管日志
 */
import styles from './logModal.scss';
import React, { Component } from 'react';
import { hashHistory } from 'react-router';
import { Modal, Form, Input, Select } from 'antd';
import { PicturePageText } from '../../../../constants/info';
import { tipsMoreN } from '../../../../utils/validator';
import messager from '../../../../utils/messager';
import GroupBox from '../../../common/groupBox/GroupBox';
import { getPageCodeByLink, checkSearch } from '../../common/commons';
import { addLog } from '../../../../services/user';
const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;

class LogModal extends Component {
    constructor(props) {
        super(props);
        const { pathname } = hashHistory.getCurrentLocation();
        this.state = {
            defaultModule: getPageCodeByLink(pathname),
            pageOptions: Object.entries(PicturePageText)
        };
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { onCancel } = this.props;
        this.props.form.validateFields({ force: true }, (err, values) => {
            if (!err) {
                let companyInfo = checkSearch();
                addLog({
                    ...values,
                    ...companyInfo,
                    stockCode: companyInfo.companyCode // 公司代码和股票代码已统一为相同的字段
                }).then(() => {
                    messager.success('保存成功，已记录到个人中心-监管日志');
                    onCancel();
                });
            }
        });
    };

    getPopupContainer = () => {
        return document.querySelector('.add-log-modal');
    };

    render() {
        const { visible, onCancel } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { defaultModule, pageOptions } = this.state;

        return (
            <Modal
                width={700}
                visible={visible}
                footer={null}
                onCancel={onCancel}
                maskClosable={false}
                className="add-log-modal"
            >
                <GroupBox title="添加监管日志">
                    <Form hideRequiredMark className={styles.logForm} onSubmit={this.onSubmit}>

                        <FormItem label="模块">
                            {getFieldDecorator('module', {
                                validateFirst: true,
                                initialValue: defaultModule,
                                rules: [{
                                    required: true, whitespace: true, message: '请输入异常描述'
                                }]
                            })(
                                <Select size="default" getPopupContainer={this.getPopupContainer}>
                                    {pageOptions && pageOptions.map(d =>
                                        <Option key={d[0]} value={d[0]}>{d[1]}</Option>
                                    )}
                                </Select>
                            )}
                        </FormItem>

                        <FormItem label="异常描述">
                            {getFieldDecorator('description', {
                                validateFirst: true,
                                rules: [{
                                    required: true, whitespace: true, message: '请输入异常描述'
                                }, {
                                    max: 300, message: tipsMoreN(300)
                                }]
                            })(
                                <TextArea placeholder="异常描述" rows={3} autoComplete="off"/>
                            )}
                        </FormItem>
                        <FormItem label="监管方向">
                            {getFieldDecorator('direction', {
                                validateFirst: true,
                                rules: [{
                                    required: true, whitespace: true, message: '请输入异常描述'
                                }, {
                                    max: 300, message: tipsMoreN(300)
                                }]
                            })(
                                <TextArea placeholder="监管方向" rows={3} autoComplete="off"/>
                            )}
                        </FormItem>
                        <FormItem label="备注">
                            {getFieldDecorator('remark', {
                                validateFirst: true,
                                rules: [{
                                    max: 200, message: tipsMoreN(200)
                                }]
                            })(
                                <TextArea placeholder="备注" rows={3} autoComplete="off"/>
                            )}
                        </FormItem>
                        <FormItem>
                            <div className="btn-group">
                                <button type="submit" className="btn btn-blue">保存</button>
                                <button type="button" className="btn" onClick={onCancel}>取消</button>
                            </div>
                        </FormItem>

                    </Form>
                </GroupBox>

            </Modal>
        );
    }
}

export default (Form.create({})(LogModal));



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/logModal/LogModal.jsx